import { A9Service, AbstractDataProviderV2, IDataProviderV2 } from 'components/system';
import { RsAddress } from 'common/customers/services/types/RsAddress';
import { RsAddressInfo } from 'common/customers/services/types/RsAddressInfo';
import { AddressAdd } from 'common/customers/services/types/AddressAdd';
import { AddressUpdate } from 'common/customers/services/types/AddressUpdate';

export function addressFromGetToUpdateParams(params: RsAddressInfo): AddressUpdate {
    return {
        defaultForSex: params.defaultForSex,
        name: params.name,
        nameLatin: params.nameLatin,
        orderNo: params.orderNo,
        sex: params.sex
    };
}

export type IAddressDataProvider = IDataProviderV2<RsAddress, RsAddressInfo, AddressAdd, AddressUpdate>;

@A9Service('addressDataProvider')
export class AddressDataProvider extends AbstractDataProviderV2<RsAddress, RsAddressInfo, AddressAdd, AddressUpdate> implements IAddressDataProvider {
    constructor() {
        super();
        this.setApiUrl('middle://rs/customers/dict/addresses');
    }

    public patch(): Promise<any> {
        return Promise.reject('method "Patch" is not supported, use "customPatch"');
    }
}
